import {
  ChangeDetectorRef,
  Component,
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatchMediaService } from 'app/shared/services/match-media.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EgretSidebarHelperService } from './egret-sidebar-helper.service';

@Component({
  selector: 'app-egret-sidebar',
  templateUrl: './egret-sidebar.component.html',
  styleUrls: ['./egret-sidebar.component.scss'],
})
export class EgretSidebarComponent implements OnInit, OnDestroy {
  // Name
  @Input()
  name: string;

  // right
  @Input()
  @HostBinding('class.position-right')
  right: boolean;

  // Open
  @HostBinding('class.open')
  opened: boolean;

  @HostBinding('class.sidebar-locked-open')
  sidebarLockedOpen: boolean;

  // mode
  @HostBinding('class.is-over')
  isOver: boolean;

  private backdrop: HTMLElement | null = null;

  private lockedBreakpoint = 'gt-sm';
  private unsubscribeAll: Subject<any>;
  watcher: Subscription

  constructor(
    private matchMediaService: MatchMediaService,
    private media: MediaObserver,
    private sidebarHelperService: EgretSidebarHelperService,
    private _renderer: Renderer2,
    private _elementRef: ElementRef,
    private cdr: ChangeDetectorRef
  ) {
    this.unsubscribeAll = new Subject();
  }

  ngOnInit() {
    this.sidebarHelperService.setSidebar(this.name, this);

    if (this.media.isActive(this.lockedBreakpoint)) {
      this.sidebarLockedOpen = true;
      this.opened = true;
    } else {
      this.sidebarLockedOpen = false;
      this.opened = false;
    }

    this.watcher = this.matchMediaService.onMediaChange
      // .pipe(takeUntil(this.unsubscribeAll))
      .subscribe(() => {
        // console.log("medua sub");
        if (this.media.isActive(this.lockedBreakpoint)) {
          this.sidebarLockedOpen = true;
          this.opened = true;
        } else {
          this.sidebarLockedOpen = false;
          this.opened = false;
        }
      });
  }

  open() {
    this.opened = true;
    if (!this.sidebarLockedOpen && !this.backdrop) {
      this.showBackdrop();
    }
  }

  close() {
    this.opened = false;
    this.hideBackdrop();
  }

  toggle() {
    if (this.opened) {
      this.close();
    } else {
      this.open();
    }
  }

  showBackdrop() {
    this.backdrop = this._renderer.createElement('div');
    this.backdrop.classList.add('egret-sidebar-overlay');

    this._renderer.appendChild(
      this._elementRef.nativeElement.parentElement,
      this.backdrop
    );

    // Close sidebar onclick
    this.backdrop.addEventListener('click', () => {
      this.close();
    });

    this.cdr.markForCheck();
  }

  hideBackdrop() {
    if (this.backdrop) {
      this.backdrop.parentNode.removeChild(this.backdrop);
      this.backdrop = null;
    }

    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    // this.unsubscribeAll.next();
    this.watcher.unsubscribe();
    this.unsubscribeAll.complete();
    this.sidebarHelperService.removeSidebar(this.name);
  }
}

@Directive({
  selector: '[appEgretSidebarToggler]',
})
export class EgretSidebarTogglerDirective {
  @Input('appEgretSidebarToggler')
  public id: any;

  constructor(private egretSidebarHelperService: EgretSidebarHelperService) {}

  @HostListener('click')
  onClick() {
    this.egretSidebarHelperService.getSidebar(this.id).toggle();
  }
}
